module.exports = __webpack_public_path__ + "img/cli_01.4f0d1f8f.png";